import { useTranslation } from 'react-i18next';

import { KeyVertical } from '@/package';
import { VButton, useFlag } from '@/package';

import { APIKeyCreationModal } from './APIKeyCreationModal';

export const APIKeyCreationButton = () => {
  const { t } = useTranslation();
  const { value: visible, setFalse: hide, setTrue: show } = useFlag(false);
  const onCreateButtonClick = () => {
    show();
  };

  return (
    <>
      <VButton className="w-fit" size="lg" onClick={onCreateButtonClick}>
        <KeyVertical />
        {t('apiKey.createButtonText.twigsome')}
      </VButton>

      <APIKeyCreationModal visible={visible} onHide={hide} onShow={show} />
    </>
  );
};

APIKeyCreationButton.displayName = 'APIKeyCreationButton';
